export default function reducer(state = {
    categories: [],
    locations: [],
    tours: [],
    update: false,
    toursArray: false
}, action) {
    switch (action.type) {
        case "STORE_THINGS_TO_DO_FILTERS": {
            return {
                ...state,
                categories: action.list.categories,
                locations: action.list.locations,
                update: true
            }
        }
        case "STORE_THINGS_TO_DO_DETAILS_UPDATE": {
            return {
                ...state,
                update: action.bool
            }
        }
        case "STORE_THINGS_TO_DO_LISTS": {
            return {
                ...state,
                tours: action.list.tours
            }
        }
        case "CLEAR_THINGS_TO_DO_LISTS": {
            return {
                ...state,
                tours: []
            }
        }
        case "UPDATE_THINGS_TO_DO_LIST_ARRAY": {
            return {
                ...state,
                toursArray: action.bool
            }
        }
        case "UPDATE_THINGS_TO_DO_MORE_LISTS": {
            return {
                ...state,
                tours: [
                    ...state.tours,
                    ...action.list.tours
                ]
            }
        }
        default:
            break;
    }
    return state
}